import React, { useContext, useEffect, useState } from "react";
import axiosInstance from "../utils/Requests/axios";
import LanguageContext from "../utils/Contexts/LanguageContext";
import UserContext from "../utils/Contexts/UserContext";
import toast from "react-hot-toast";

function FilterSaveModal({ formData, filterData, setFilterData, selectedFilter }) {
  const { t } = useContext(LanguageContext);
  const { userData } = useContext(UserContext);
  const [filterName, setFilterName] = useState("");
  const [notify, setNotify] = useState(false);
  const [initial, setInitial] = useState(false);
  
  const saveFilter = async () => {
    try {
      const payload = {
        name: filterName,  
        notify: notify,    
        initial: initial, 
        filters: formData.search.filters
      };
  
      // POST request
      const response = await axiosInstance.post(`users/${userData?.uuid}/preferences/filters`, payload);
      closeModal();
      let tempFilterData = [...filterData];
      tempFilterData.push({
        filters: response?.data?.filters,
        initial: response?.data?.initial,
        name: response?.data?.name,
        notify: response?.data?.notify,
        uuid: response?.data?.uuid,
      });
      setFilterData(tempFilterData);
    } catch (error) {
      toast.error(t(`There was an error saving the filter`));
    }
  };

  const closeModal = () => {
    const closeButton = document.querySelector('#modal-sm-filters-save [data-bs-dismiss="modal"]');
    if (closeButton) {
      closeButton.click(); 
    } else {
      console.error('Close button not found.');
    }
  };

  const handleFilterNameChange = (e) => {
    setFilterName(e.target.value);
  };
  
  const handleNotifyChange = (e) => {
    setNotify(e.target.checked);
  };
  
  const handleInitialChange = (e) => {
    setInitial(e.target.checked);
  };

  useEffect(() => {
    if (selectedFilter?.uuid) {
      setFilterName(selectedFilter.name);
      setNotify(selectedFilter.notify);
      setInitial(selectedFilter.initial);
    }
  }, [selectedFilter]);

  return (
    <div
      id="modal-sm-filters-save"
      className="modal fade"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="mySmallModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="modal-title h3" id="mySmallModalLabel">
              {t("Save Filters")}
            </h3>
          </div>
          <div className="modal-body">
            <div className="mb-4">
              <input
                type="text"
                id="exampleFormControlInput1"
                className="form-control"
                placeholder={t("Filters Name")}
                value={filterName}
                onChange={handleFilterNameChange}
              />
            </div>

            <div className="form-check form-switch mb-4">
              <input
                type="checkbox"
                className="form-check-input"
                id="formSwitch1"
                checked={notify}
                onChange={handleNotifyChange}
              />
              <label className="form-check-label" htmlFor="formSwitch1">
                {t("Email me of new sites that match")}
              </label>
            </div>
            <div className="form-check form-switch mb-4">
              <input
                type="checkbox"
                className="form-check-input"
                id="formSwitch2"
                checked={initial}
                onChange={handleInitialChange}
              />
              <label className="form-check-label" htmlFor="formSwitch2">
                {t("Apply filter for initial Offers Search load")}
              </label>
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-white" data-bs-dismiss="modal">
              {t("Close")}
            </button>
            <button type="button" className="btn btn-primary" onClick={() => saveFilter()}>
              {t("Save")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FilterSaveModal;
